import { FunctionComponent } from "react";
import { Section, Tile } from "@Types/pagify";
import { LargeProductCardsItem } from "./LargeProductCardsItem";
import "./style.scss";

export const LargeProductCards: FunctionComponent<{
  section: Section;
  tiles: Tile[];
}> = ({ section, tiles }) => {
  return (
    <div className="LargeProductCards">
      <h1 className="LargeProductCards-title">{section.title}</h1>
      <div className="LargeProductCards-separator" />
      <div className="LargeProductCards-subtitle">
        {section.subtitle.map((textBlock) => (
          <div dangerouslySetInnerHTML={{ __html: textBlock.text }} key={textBlock.text} />
        ))}
      </div>
      <div className="LargeProductCards-item-wrapper">
        {tiles.map((tile) => (
          <LargeProductCardsItem key={tile.slug} tile={tile} />
        ))}
      </div>
    </div>
  );
};
